import React, { useEffect, useRef, useSyncExternalStore } from 'react';
import { useBlocker, useLocation, useNavigate } from 'react-router-dom';
import { draftVersion, dropDraft, pendingDrafts, subscribeDrafts } from './packToroDrafts';

export default function PackToroNavigationGuard() {
  useSyncExternalStore(subscribeDrafts, draftVersion);
  const location = useLocation();
  const navigate = useNavigate();
  const dialog = useRef(null);
  const pending = pendingDrafts();
  const blocker = useBlocker(({ nextLocation }) => pending.some(([protocol, draft]) => {
    const destination = nextLocation.pathname;
    const allowedEdit = !draft.pending && draft.rows.some((row) => row.protocolo_muestra && destination === `/editar-muestra/${row.protocolo_muestra}`);
    const allowedGeneralEntry = !draft.pending && draft.requiresGeneralSample && destination === '/ingreso-muestra' && nextLocation.state?.protocoloGeneral === protocol;
    return destination !== `/pack-toro/${protocol}` && !allowedEdit && !allowedGeneralEntry;
  }));
  const hasPending = pending.length > 0;
  useEffect(() => {
    if (!hasPending) return undefined;
    const warn = (event) => { event.preventDefault(); event.returnValue = ''; };
    window.addEventListener('beforeunload', warn);
    return () => window.removeEventListener('beforeunload', warn);
  }, [hasPending]);
  useEffect(() => {
    if (blocker.state === 'blocked') dialog.current?.showModal();
  }, [blocker.state]);
  if (blocker.state !== 'blocked') return null;
  const uncertain = pending.some(([, draft]) => draft.pending);
  return <dialog ref={dialog} className="surface-card pack-dialog" role="alertdialog" aria-labelledby="pack-leave-title" onCancel={(event) => { event.preventDefault(); blocker.reset(); }}>
    <h2 id="pack-leave-title">Hay cambios de Pack Toro pendientes</h2>
    <p>{uncertain ? 'Primero confirma el guardado pendiente con Reintentar guardado. Así evitamos duplicar muestras.' : 'Puedes volver a la carga para guardar, seguir editando o descartar los cambios antes de salir.'}</p>
    <div className="d-flex flex-wrap gap-2">
      <button autoFocus className="btn btn-brand" onClick={() => blocker.reset()}>Seguir editando</button>
      <button className="btn btn-outline-brand" onClick={() => { blocker.reset(); if (location.pathname !== `/pack-toro/${pending[0][0]}`) navigate(`/pack-toro/${pending[0][0]}`); }}>Volver al pack para guardar</button>
      {!uncertain && <button className="btn btn-outline-danger" onClick={() => { pending.forEach(([protocol]) => dropDraft(protocol)); blocker.proceed(); }}>Descartar y salir</button>}
    </div>
  </dialog>;
}
